import React from "react";
import FilterList from "@material-ui/icons/FilterList";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

/**
 * search button
 */
export default function SearchButton({ mainGroup, handleSearch, className }) {
  return (
    ["driver"].indexOf(mainGroup) === -1 && (
      <Button
        variant="contained"
        color="primary"
        className={className}
        size="medium"
        startIcon={<FilterList />}
        onClick={handleSearch}
      >
        Aplicar Filtro
      </Button>
    )
  );
}

SearchButton.propTypes = {
  mainGroup: PropTypes.string.isRequired,
  handleSearch: PropTypes.func,
};
